import useAccountManagementLanding from "./UseAccountManagementLanding";

import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

import Constants from "@usas/ui-web/utils/Constants";

const AccountManagementLanding = () => {
  useAccountManagementLanding();

  return (
    <PopUpModal
      widthPct={90}
      maxWidth={250}
      title={Constants.LOADING_MSG}
      displayPopUp={true} />
  );
};

export default AccountManagementLanding;